import {
    TbArrowsExchange,
    TbChartInfographic,
    TbFileCertificate,
    TbFileDescription,
    TbFileInvoice,
    TbFiles,
    TbMessages,
    TbReportAnalytics,
    TbScale,
    TbSpeakerphone,
    TbUserDollar,
    TbUsersGroup,
} from 'react-icons/tb';

import type { FilingCategory } from './types';

export const filingCategories: FilingCategory[] = [
    {
        icon: TbFiles,
        key: 'all',
        title: 'All Filings',
    },
    {
        alwaysVisible: true,
        icon: TbChartInfographic,
        key: 'investor-materials',
        kinds: ['investor-material'],
        title: 'Investor Relations & Presentation Materials',
    },
    {
        icon: TbReportAnalytics,
        key: 'reports',
        title: 'Annual, Quarterly, and Current Reports',
        forms: ['10-K', '10-Q', '8-K', '20-F', '40-F', '6-K'],
    },
    {
        icon: TbUserDollar,
        key: 'insider',
        title: 'Insider Equity Awards, Transactions, and Ownership',
        forms: ['3', '4', '5', '144'],
    },
    {
        icon: TbUsersGroup,
        key: 'beneficial',
        title: 'Beneficial Ownership Reports',
        forms: ['SC 13D', 'SC 13G', '13F-HR', '13F-NT'],
    },
    {
        icon: TbFileInvoice,
        key: 'exempt',
        title: 'Exempt Offerings',
        forms: ['D'],
    },
    {
        icon: TbFileCertificate,
        key: 'registration',
        title: 'Registration Statements and Prospectuses',
        forms: ['S-1', 'S-3', 'S-4', 'S-8', 'F-1', 'F-3', 'F-4', '424B', 'FWP'],
    },
    {
        icon: TbMessages,
        key: 'correspondence',
        title: 'Filing Review Correspondence',
        forms: ['UPLOAD', 'CORRESP'],
    },
    {
        icon: TbScale,
        key: 'orders',
        title: 'SEC Orders and Notices',
        forms: ['25', 'EFFECT', 'CERT'],
    },
    {
        icon: TbSpeakerphone,
        key: 'proxy',
        title: 'Proxy Materials',
        forms: ['DEF 14A', 'DEFA14A', 'PRE 14A', 'PREC14A'],
    },
    {
        icon: TbArrowsExchange,
        key: 'tender',
        title: 'Tender Offers and Going Private Transactions',
        forms: ['SC TO', 'SC 13E3', 'SC 14D9', 'CB'],
    },
    {
        icon: TbFileDescription,
        key: 'trust',
        title: 'Trust Indenture Filings',
        forms: ['T-3', '305B2'],
    },
];
